module.exports = __webpack_public_path__ + "static/media/DELETEstyledmenu-arrow-down.44402aaa.svg";